import SectorsDetailsContainer from '../../modules/Sectors/containers/SectorDetailsContainer';
import { AppPaths } from '../../helpers/globals/Constans.ts';

// Sync route definition
export default {
  path: `${AppPaths.HOME}*${AppPaths.SECTORS}`,
  component: SectorsDetailsContainer,
};
